import styles from './MonthlyDetails.scss';

import cx from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from 'src/components/Cart/UseCart';

import { Grid } from 'src/components/Grid/Grid';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { Installments } from '../../OrderSummary/types';
import { INSTALLMENT_LENGTH, getInstallmentMonth } from '../InstallmentDetailsUtils';

interface MonthlyDetailsProps {
  month: number;
}

export const MonthlyDetails : FC<MonthlyDetailsProps> = ({ month = 1 }) => {
  const { t } = useTranslation();
  const { cart, checkout } = useCart();

  const { softwarePlan } = cart || {};
  const { installmentPlans, softwareTotal } = checkout || {};

  const installmentLength = INSTALLMENT_LENGTH[Installments.IP3];
  const isFirstMonth = month === 1 ;

  const hardwareCost = installmentLength === 1 ? checkout?.subtotal : installmentPlans?.find(plan => plan.id === Installments.IP3.toString())?.cost || 0;
  const registerPlan = softwarePlan?.name || t('installment-details.register-plan');

  const cost = month === installmentLength + 1 ? 0 : hardwareCost;

  return (
    <Grid container className={styles.container}>
      <TextV2
        value={`${t('installment-details.installment-month', { installmentMonth: getInstallmentMonth(month) })} ${month === installmentLength + 1 ? t('installment-details.and-after') : ''}`.trim()}
        variant="eyebrow"
        tagName="p"
        className={styles.containerTitle}
      />
      <div className={styles.containerDescription}>
        <Grid container justifyContent="space-between">
          <Grid item xs={6} sm={6} md={3}>
            <TextV2
              variant="h4"
              tagName="h4"
              value={t('installment-details.price', { price: cost })}
              data-test="hardware-cost"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <div className={styles.containerDescriptionRegister}>
              <TextV2
                variant="h4"
                tagName="h4"
                value={t('installment-details.price', { price: softwareTotal })}
                className={cx({ [styles.containerDescriptionFirstMonth]: isFirstMonth })}
              />
              {isFirstMonth && <TextV2 variant="h4" tagName="h4" value="$0" data-test="first-month-register-plan" />}
            </div>
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between">
          <Grid item xs={6} sm={6} md={3}>
            <TextV2
              variant="small"
              tagName="small"
              value={`${t('installment-details.hardware-costs')} ${isFirstMonth ? t('installment-details.plus-tax') : ''}`.trim()}
              data-test="hardware-cost-info"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <TextV2
              variant="small"
              tagName="small"
              value={`${registerPlan}${isFirstMonth ? t('installment-details.30-day-free') : ''}`}
              data-test="register-plan-info"
              className={styles.containerDescriptionRegister}
            />
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};
